function ContactOptionsDataLayer(orderId, orderStatus, contactType) {
  const event = {
    event: 'ca_contact_button_click',
    contact_button_click: {
      order_id: orderId,
      order_status: orderStatus,
      contact_type: contactType,
    },
  };

  window.dataLayer.push(event);
}

export default ContactOptionsDataLayer;
